var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionListTemplate',{ref:"bank-transactions-list",attrs:{"screenConfig":_vm.setScreenConfig,"setLoading":_vm.setLoading,"persistenceKey":'bank-transactions-list',"rowClick":_vm.rowClickCallBack}})}
var staticRenderFns = []

export { render, staticRenderFns }